import { Environment, CameraControls, Html, PerspectiveCamera, Line, Text } from '@react-three/drei'
import { useEffect, useRef, useState } from 'react'
import useGame from './stores/useGame.jsx'
import * as THREE from'three'
import { Leva, useControls } from 'leva'
import { Starlink } from './starlink.jsx'
import { ClosedDimentions } from './closedDimentions.jsx'
import { Effects } from './Effects'

const { DEG2RAD } = THREE.MathUtils

var audioTrigger = false

export default function Experience()
{
    const phase = useGame((state) => state.phase)
    const touched = useGame((state) => state.touched)
    const openAnimFinished = useGame((state) => state.openAnimFinished)


    const play = useGame((state) => state.play)
    const rotate =  useGame((state) => state.rotate)

    const solarOpen = useGame((state) => state.solarOpen)
    const solarFlat = useGame((state) => state.solarFlat)
    
    const showSize = useGame((state) => state.showSize)
    const toggleShowSize = useGame((state) => state.toggleShowSize)

    const cameraControlsRef = useRef()

    var closedDimentions = false



    const p1 = useGame((state) => state.p1)
    const p2 = useGame((state) => state.p2)
    const p3 = useGame((state) => state.p3)
    const p4 = useGame((state) => state.p4)
    const p5 = useGame((state) => state.p5)
    const p6 = useGame((state) => state.p6)
    const p7 = useGame((state) => state.p7)

    const infoPanel = useGame((state) => state.infoPanel)

    const efRef = useRef()
    const dofRef = useRef()

    const {...efConfig} = useControls('PostProcessing',{
        enabled: true
    })

    
    const {...dofConfig} = useControls('DOF',{
        focalLength: {value: 0.50, min: 0.00, max: 0.50, step: 0.01},
        focusRange: { min: 0, max: 1, value: 0.01 },
        bokehScale: {value: 4.0, min: 0.0, max: 5.0, step: 0.1}
    })

    useEffect(()=>
    {
        if(play === true && solarOpen === false)
            {
                var position = new THREE.Vector3(8,3,8)
                var target = new THREE.Vector3(0,2,0)
                cameraControlsRef.current.setLookAt(...position, ...target, true)
                
            }

        if(play === true && solarOpen === true)
            {
                var position = new THREE.Vector3(4, 2, 4)
                var target = new THREE.Vector3(0,0,0)
                cameraControlsRef.current.setLookAt(...position, ...target, true)
                
            }

        if(rotate === true && solarFlat === false)
            {
                var position = new THREE.Vector3(8,2,-8)
                var target = new THREE.Vector3(0,0,-2)
                cameraControlsRef.current.setLookAt(...position, ...target, true)
                
            }

        if(rotate === true && solarFlat === true)
            {
                var position = new THREE.Vector3(8,3,8)
                var target = new THREE.Vector3(0,2,0)
                cameraControlsRef.current.setLookAt(...position, ...target, true)
                
            }

    },[play, rotate])

    useEffect(() =>
    {
        const state = useGame.getState()

            if (state.infoPanel === 'null')
                { 
                    cameraControlsRef.current?.reset(true)
                }        
    }, [infoPanel])



        const LaunchPoint = (panelNumber, position, target) =>
        {
            panelNumber()
            console.log(position)
            console.log(target)
            cameraControlsRef.current.setLookAt(...position, ...target, true)
        }


        const Points = () =>
            {

            return  <>

                    { play === false && solarOpen === false && showSize === false && <>
                        <Html wrapperClass='point' position={new THREE.Vector3(0,1,0.0)}  > 
                            <div className="pulse" onClick={()=> { toggleShowSize();   } }></div>
                            <div className="label" onClick={()=> { toggleShowSize();  } }>i</div> 
                        </Html>
                    </>}

                    { play === false && solarOpen === false && showSize === true && <>
                        <Html wrapperClass='point' position={new THREE.Vector3(0,1,0.0)}  > 
                            <div className="pulse" onClick={()=> { toggleShowSize();   } }></div>
                            <div className="label" onClick={()=> { toggleShowSize();  } }>i</div> 
                        </Html>
                    </>}

                    { openAnimFinished === true && infoPanel === 'null' &&<>
                        <Html wrapperClass='point' position={new THREE.Vector3(-0.3,1.3,0.8)}  > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p1, new THREE.Vector3(-1.6,1.2,1.6), new THREE.Vector3(-0.6,1.0,0.8)) } }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p1, new THREE.Vector3(-1.6,1.2,1.6), new THREE.Vector3(-0.6,1.0,0.8)) } }>1</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(-0.5,0.9,-1.1)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p2, new THREE.Vector3(-1.5,0.9,-0.6), new THREE.Vector3(-0.5,0.6,-1.1))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p2, new THREE.Vector3(-1.5,0.9,-0.6), new THREE.Vector3(-0.5,0.6,-1.1))} }>2</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(-0.7,0.5,0.8)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p3, new THREE.Vector3(-1.5,0.5,1), new THREE.Vector3(-0.6,0.4,0.7))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p3, new THREE.Vector3(-1.5,0.5,1), new THREE.Vector3(-0.6,0.4,0.7))} }>3</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(-0.3,0.25,0.2)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p4, new THREE.Vector3(0.1,0.4,0.5), new THREE.Vector3(-0.45,0.25,0.3))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p4, new THREE.Vector3(0.1,0.4,0.5), new THREE.Vector3(-0.45,0.25,0.3))} }>4</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(0.1,0.2,1.0)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p5, new THREE.Vector3(0.1,0.2,1.6), new THREE.Vector3(-0.16,0.1,1.0))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p5, new THREE.Vector3(0.1,0.2,1.6), new THREE.Vector3(-0.16,0.1,1.0))} }>5</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(0.75,-0.1,1.3)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p6, new THREE.Vector3(1,0.1,1.8), new THREE.Vector3(0.5,-0.1,1.3))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p6, new THREE.Vector3(1,0.1,1.8), new THREE.Vector3(0.5,-0.1,1.3))} }>6</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(0.5,1.0,2.3)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p7, new THREE.Vector3(1,1.0,2.7), new THREE.Vector3(0.4,0.9,2.1))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p7, new THREE.Vector3(1,1.0,2.7), new THREE.Vector3(0.4,0.9,2.1))} }>7</div> 
                        </Html>
                        </>
                    }

                    </>
            }
    
            const lineMaterial = new THREE.MeshStandardMaterial()
            console.log(lineMaterial)

        
    const SpawnLine = ()=>
    {
        return<>



            </>
    }

     return <>
            {/* <Perf /> */}
            <Leva hidden={true} />

                <CameraControls 
                            ref={cameraControlsRef}
                            minDistance={4}
                            maxDistance={10}
                            onChange={touched}
                            smoothTime={2.5}
                            makeDefault
                    />

                <PerspectiveCamera 
                        makeDefault
                        fov= {45}
                        near={0.1}
                        far={2000}
                        position= {[ 4, 2, 4 ]}
                />

                <Starlink rotation={[0,0,0]}/>

                <Points/>
                <Effects />

                <Environment 
                    files="earth2.hdr"
                    background={true} 
                    backgroundIntensity={0.01}                    
                    />

                
                    <ClosedDimentions/>

                  
    </>
}